import Navbar from "@/components/LandingPage/Navbar";
import Footer from "@/components/LandingPage/Footer";
import { motion } from "framer-motion";

export default function Privacy() {
  return (
    <div className="bg-bg-primary min-h-screen flex flex-col">
      <Navbar />
      <main className="grow pt-32 pb-20 px-6">
        <div className="mx-auto max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-12"
          >
            <h1 className="font-display text-4xl sm:text-5xl mb-6 text-text-primary">
              Privacy <span className="text-ember">Policy</span>
            </h1>
            <p className="text-text-muted text-sm uppercase tracking-widest font-bold mb-8">
              Last Updated: March 26, 2026
            </p>
          </motion.div>

          <div className="prose prose-invert max-w-none text-text-muted leading-relaxed space-y-8">
            <section>
              <h2 className="text-xl font-display text-text-primary mb-4">
                1. Information We Collect
              </h2>
              <p>
                We collect information you provide directly to us when you
                create an account, make internal transfers, or communicate with
                our support team. This may include your name, email address,
                wallet addresses, and any other information you choose to
                provide.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-display text-text-primary mb-4">
                2. How We Use Your Information
              </h2>
              <p>
                Your information is used to provide, maintain, and improve our
                services, process transactions, send technical notices, and
                communicate about products, services, and events offered by
                MineMe.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-display text-text-primary mb-4">
                3. Data Security
              </h2>
              <p>
                MineMe implements industry-standard security measures to
                protect your personal information from unauthorized access,
                alteration, or destruction. We utilize multi-layered encryption
                and secure server environments to safeguard your data.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-display text-text-primary mb-4">
                4. Third-Party Sharing
              </h2>
              <p>
                We do not share your personal information with third parties
                except as required by law or to facilitate transactions
                initiated by you. We do not sell your personal data to
                advertisers or other external entities.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-display text-text-primary mb-4">
                5. Your Privacy Rights
              </h2>
              <p>
                Depending on your location, you may have rights to access,
                update, or delete your personal information. Please contact our
                data protection team if you wish to exercise these rights or if
                you have any questions regarding our privacy practices.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
